import React from 'react';
import { arrayOf, func, number, shape, string, bool } from 'prop-types';
import { routePush } from '@magalu/mixer-utils';
import { usePublisher } from '@magalu/mixer-publisher';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { Container, Title, List, Link, Separator } from './SeoLinkList.styles';
var SEPARATOR = ' – ';
var getVisibleItems = function getVisibleItems(items, characterLimit) {
  var total = 0;
  var visible = [];
  for (var i = 0; i < items.length; i += 1) {
    var _items$i$label$length, _items$i$label;
    var separatorLength = i > 0 ? SEPARATOR.length : 0;
    var nextTotal = total + separatorLength + ((_items$i$label$length = (_items$i$label = items[i].label) == null ? void 0 : _items$i$label.length) !== null && _items$i$label$length !== void 0 ? _items$i$label$length : 0);
    if (nextTotal > characterLimit) break;
    total = nextTotal;
    visible.push(items[i]);
  }
  return visible;
};
var SeoLinkList = function SeoLinkList(_ref) {
  var staticProps = _ref["static"];
  var _staticProps$characte = staticProps.characterLimit,
    characterLimit = _staticProps$characte === void 0 ? 800 : _staticProps$characte,
    _staticProps$items = staticProps.items,
    items = _staticProps$items === void 0 ? [] : _staticProps$items,
    onClickItem = staticProps.onClickItem,
    title = staticProps.title,
    _staticProps$titleTag = staticProps.titleTag,
    titleTag = _staticProps$titleTag === void 0 ? 'h2' : _staticProps$titleTag;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var visibleItems = getVisibleItems(items, characterLimit);
  var handleClick = function handleClick(e, item) {
    publish('listlink:click', {
      value: {
        label: item.label
      }
    });
    if (item.targetBlank) return;
    e.preventDefault();
    if (onClickItem) {
      onClickItem(e, item);
      return;
    }
    routePush({
      path: item.href,
      spa: true
    });
  };
  return React.createElement(Container, {
    "data-testid": "seo-link-list"
  }, title && React.createElement(Title, {
    as: titleTag,
    "data-testid": "seo-link-list-title"
  }, title), React.createElement(List, {
    "data-testid": "seo-link-list-list"
  }, visibleItems.length === 0 ? React.createElement("span", {
    "data-testid": "seo-link-list-empty"
  }, "Nenhum link relacionado dispon\xEDvel.") : visibleItems.map(function (item, index) {
    var _item$id;
    return React.createElement(React.Fragment, {
      key: (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : "".concat(item.label, "-").concat(index)
    }, index > 0 && React.createElement(Separator, {
      "aria-hidden": "true"
    }, SEPARATOR), React.createElement(Link, {
      "data-testid": "seo-link-list-item",
      href: item.href,
      onClick: function onClick(e) {
        return handleClick(e, item);
      },
      rel: item.targetBlank ? 'noopener noreferrer' : undefined,
      target: item.targetBlank ? '_blank' : undefined,
      title: item.title || undefined
    }, item.label));
  })));
};
SeoLinkList.ssr = true;
process.env.NODE_ENV !== "production" ? SeoLinkList.propTypes = {
  "static": shape({
    characterLimit: number,
    items: arrayOf(shape({
      href: string.isRequired,
      id: string,
      label: string.isRequired,
      targetBlank: bool,
      title: string
    })),
    onClickItem: func,
    title: string,
    titleTag: string
  })
} : void 0;
SeoLinkList.defaultProps = {
  "static": {}
};
export default withLayoutProps(SeoLinkList);